import noop from 'lodash/noop';
import {
  CONFIRM_ACTION_ASK_CONFIRM_ACTION,
  CONFIRM_ACTION_CALLBACK,
  CONFIRM_ACTION_CANCEL_ACTION,
  CONFIRM_ACTION_CONFIRM_ACTION,
  CONFIRM_ACTION_HIDE_CONFIRM_ACTION_MODAL,
  CONFIRM_ACTION_SET_NEXT_ACTION,
  CONFIRM_ACTION_SHOW_CONFIRM_ACTION_MODAL,
} from './constants';

export const defaultConfirmActionText: {
  titleBodyText?: string;
  bodyText?: string;
  titleText?: string;
  okText?: string;
  cancelText?: string;
  headerClass?: string;
} = {
  titleBodyText: 'Do you want to leave this page?',
  bodyText: 'Changes you made may not be saved.',
  titleText: 'Leaving Page',
  okText: 'Leave',
  cancelText: 'Stay',
  headerClass: 'modal-header-primary',
};

/** **************************************************************************************************
 * Action Confirmation
 *************************************************************************************************** */

export function showConfirmActionModal(customText) {
  return {
    type: CONFIRM_ACTION_SHOW_CONFIRM_ACTION_MODAL,
    payload: { customText },
  };
}

export function hideConfirmActionModal() {
  return { type: CONFIRM_ACTION_HIDE_CONFIRM_ACTION_MODAL, payload: {} };
}

export function confirmAction(nextAction) {
  return { type: CONFIRM_ACTION_CONFIRM_ACTION, payload: { nextAction } };
}

export function askConfirmAction(
  nextAction,
  customText = defaultConfirmActionText,
  isThunk = false,
  callback = noop
) {
  return {
    type: CONFIRM_ACTION_ASK_CONFIRM_ACTION,
    payload: { nextAction, customText, isThunk, callback },
  };
}

export function cancelAction() {
  return { type: CONFIRM_ACTION_CANCEL_ACTION, payload: {} };
}

export function setNextAction(nextAction) {
  return { type: CONFIRM_ACTION_SET_NEXT_ACTION, payload: { nextAction } };
}

export function setCallback(callback) {
  return {
    type: CONFIRM_ACTION_CALLBACK,
    payload: { callback },
  };
}

/** **************************************************************************************************
 * End Action Confirmation
 *************************************************************************************************** */
